/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Creem_Signing_SecretInputs */

const en_admin_settings_fields_creem_signing_secret = /** @type {(inputs: Admin_Settings_Fields_Creem_Signing_SecretInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signing Secret`)
};

const zh_admin_settings_fields_creem_signing_secret = /** @type {(inputs: Admin_Settings_Fields_Creem_Signing_SecretInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signing Secret`)
};

/**
* | output |
* | --- |
* | "Signing Secret" |
*
* @param {Admin_Settings_Fields_Creem_Signing_SecretInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_creem_signing_secret = /** @type {((inputs?: Admin_Settings_Fields_Creem_Signing_SecretInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Creem_Signing_SecretInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_fields_creem_signing_secret(inputs)
	return zh_admin_settings_fields_creem_signing_secret(inputs)
});
export { admin_settings_fields_creem_signing_secret as "admin.settings.fields.creem_signing_secret" }